import React, {useState} from 'react'
import styled from "styled-components";
import {Button, Form, Input, InputNumber, Select, Table} from "antd";
import {ColumnsType} from "antd/es/table";
import {useQuery} from "react-query";
import {REPO} from "../../Repository/repo";
import {queryKeys} from "../../Constant/QueryKeys";
import {DEFAULT_LIST_COUNT} from "../../Constant/Common";
import BranchSelect from "../../Components/BranchSelect/BranchSelect";
import {SearchRow, SearchWrap} from "../../Components";
import {VacationAnnualRow} from "../../Model/VacationModel";
import AnnualLeaveModal from "./AnnualLeaveModal";

const Wrap = styled.div`
  .filters { margin-bottom: 12px; }
`

const AnnualLeaveList: React.FC = () => {
    const [form] = Form.useForm()
    const [baseYear, setBaseYear] = useState<number>(new Date().getFullYear())
    const [branchSeq, setBranchSeq] = useState<number | undefined>(undefined)
    const [status, setStatus] = useState<string>("1")
    const [keyword, setKeyword] = useState<string>("")
    const [limit, setLimit] = useState<number>(DEFAULT_LIST_COUNT)
    const [offset, setOffset] = useState<number>(0)
    const [modalEmployee, setModalEmployee] = useState<{ seq: number, name: string } | null>(null)

    const {data, refetch} = useQuery(
        [...queryKeys.vacationAnnual, branchSeq, baseYear, status, keyword, limit, offset],
        async () => {
            const res = await REPO.Vacation.GetAnnualList({
                base_year: baseYear,
                branch_seq: branchSeq,
                status,
                search_query: keyword,
                limit,
                offset,
            })
            return res.data
        }
    )

    const columns: ColumnsType<VacationAnnualRow> = [
        {title: '사원번호', dataIndex: 'employee_no', key: 'employee_no'},
        {title: '이름', dataIndex: 'employee_name', key: 'employee_name'},
        {title: '직책', dataIndex: 'employee_position', key: 'employee_position'},
        {title: '소속지점', dataIndex: 'branch_name', key: 'branch_name'},
        {title: '입사일', dataIndex: 'employee_begin', key: 'employee_begin'},
        {title: '지급연차', dataIndex: 'granted', key: 'granted', render: (v) => `${v}일`},
        {
            title: '사용',
            dataIndex: 'used',
            key: 'used',
            render: (v, r) => (
                <>
                    {v}일
                    {!!r.pending && <span style={{color: '#FAAD14', marginLeft: 4}}>(요청중 {r.pending}일 포함)</span>}
                </>
            )
        },
        {
            title: '잔여',
            dataIndex: 'remaining',
            key: 'remaining',
            render: (v) => <b style={{color: v < 0 ? '#FF4D4F' : '#1677ff'}}>{v}일</b>
        },
        {
            title: '관리',
            key: 'manage',
            render: (_, r) => (
                <Button size={"small"} onClick={() => setModalEmployee({seq: r.employee_seq, name: r.employee_name})}>
                    사용내역
                </Button>
            ),
        },
    ]

    const onSearch = (values: any) => {
        setBaseYear(Number(values.base_year ?? new Date().getFullYear()))
        setStatus(values.status ?? "1")
        setKeyword(values.search_query || "")
        setOffset(0)
    }

    return (
        <Wrap>
            <SearchWrap form={form} onFinish={onSearch} initialValues={{base_year: baseYear, status: "1"}}>
                <SearchRow>
                    <Form.Item label={"기준연도"} name={"base_year"}>
                        <InputNumber min={2000} max={2100}/>
                    </Form.Item>
                    <Form.Item label={"소속"}>
                        <BranchSelect
                            groupSelect
                            allHide
                            onChange={(v: any) => setBranchSeq(v ? Number(v) : undefined)}
                            value={branchSeq}
                        />
                    </Form.Item>
                    <Form.Item label={"상태"} name={"status"}>
                        <Select style={{width: 100}}>
                            <Select.Option value={""}>전체</Select.Option>
                            <Select.Option value={"1"}>정상</Select.Option>
                            <Select.Option value={"2"}>퇴사</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label={"이름"} name={"search_query"}>
                        <Input allowClear placeholder={"직원명"}/>
                    </Form.Item>
                    <Button type={"primary"} htmlType={"submit"}>검색</Button>
                </SearchRow>
            </SearchWrap>

            <Table
                rowKey={"employee_seq"}
                dataSource={data?.list || []}
                columns={columns}
                pagination={{
                    pageSize: limit,
                    total: data?.total || 0,
                    showSizeChanger: true,
                    onChange: (page, pageSize) => {
                        setOffset((page - 1) * (pageSize || limit))
                        if (pageSize) setLimit(pageSize)
                    },
                }}
            />

            {modalEmployee && (
                <AnnualLeaveModal
                    employeeSeq={modalEmployee.seq}
                    employeeName={modalEmployee.name}
                    baseYear={baseYear}
                    onClose={() => {
                        setModalEmployee(null)
                        refetch()
                    }}
                />
            )}
        </Wrap>
    )
}

export default AnnualLeaveList
